// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export const environment = {
  ENV_MODE: "development",
  APP_VERSION: "1.0.0",
  LS_SECRET: "NOT USED",
  CRYPTO_SECRET: "NOT USED",

  // for Captcha verification
  CAP_BASE_URL: "https://cap.bennu-edu.com",
  CAP_SITE_KEY_EGY: "e65db6a4c9",
  CAP_SITE_KEY_ARE: "e65db6a4c9",
  CAP_SITE_KEY_SAU: "e65db6a4c9",
  CAP_SITE_KEY_OMN: "e65db6a4c9",

  FRESH_CHAT_WIDGET_TAGS: ["stagging_dashboard"],
  FRESH_CHAT_WIDGET_UUID: "a85133ca-39f7-4924-a335-9a46fdf57d67",

  STATEMENTS_SERVICE_NAME: "MONTHLY STATEMENT",
  STATEMENTS_SERVICE_NAME_ALPHA: "MERCHANT STATEMENT",
  DIGEST_SERVICE_NAME: "DIGEST",

  GTM_ID: "GTM-T9JNXZG",
  
  AMPLITUDE_API_KEY: "065b5c7006217b92558f60e2adffdb97",
};
